// Centralized PLATFORM-level brand defaults for B∞kd.
//
// Per-tenant values (salon name, logo, colours, phone, social links etc.)
// always come from `GET /api/settings`. These constants are used ONLY as a
// neutral last-resort fallback when settings are unavailable (e.g. during
// initial load). They MUST stay tenant-agnostic — never hardcode any
// individual salon's branding here.

export const BRAND = {
  name: "B∞kd",
  tagline: "Beauty bookings, beyond",
  slug: "",
  logo: "",
  location: "",
  phone: "",
  email: "",
  website: "https://bookdbeyond.com",
  social: {
    tiktok: "",
    instagram: "",
    facebook: "",
    whatsapp: "",
  },
  colors: {
    primary: "#3d3433",       // warm charcoal
    primaryLight: "#6b5b58",  // lighter charcoal
    accent: "#c9a89c",        // soft blush/nude
    accentLight: "#e8d5cf",   // lighter blush
    background: "#faf7f6",    // warm off-white
    card: "#ffffff",
    text: "#3d3433",
    textMuted: "#8a7e7b",
    border: "#e8e0dd",
  }
};
